/* eslint-disable @typescript-eslint/no-explicit-any */
import { SerializedError } from '@reduxjs/toolkit';
import { DefaultError, UserRoles } from './types';
import { NumericFormatProps, numericFormatter } from 'react-number-format';
import _ from 'lodash';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import i18n from '../i18n';
import { SUPPORTED_LANGUAGES } from '@/constants';
import { Currency } from '../api/types';
export * from './localStorage';
export * from './international-deal';
export * from './lang';

export const sleep = (ms: number, reject?: boolean): Promise<void> => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      if (reject) rej();
      res();
    }, ms);
  });
};

export const getFetchEror = (
  error: DefaultError | SerializedError | FetchBaseQueryError | undefined
) => {
  const t = i18n.t.bind(i18n);

  if (!error) return '';
  if ('status' in error && error.status === 'PARSING_ERROR') {
    return t('error');
  }
  if ('data' in error) {
    return (error?.data as any)?.error?.msg;
  }

  return t('error');
};

export const blobToBase64 = (blob: Blob) => {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      res(reader.result);
    };
    reader.onerror = () => {
      rej();
    };
  });
};

export const dataURItoBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  return new Blob([arrayBuffer], { type: mimeString });
};

export const getBase64 = (file: File): Promise<string> => {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      res(reader.result as string);
    };
    reader.onerror = (error) => {
      rej(error);
    };
  });
};

export const getFileNameAndExtFromPdfBase64 = (base64: string) => {
  const base64Parts = base64.split(',');
  const contentType = base64Parts[0].split(':')[1].split(';')[0];
  const ext = contentType.split('/')[1];
  const fileName = base64Parts[0].split(':')[1].split(';')[1].split('=')[1];
  return { fileName, ext };
};

export const decodePdfBase64ToFile = (
  base64String: string,
  name = 'document.pdf'
): File => {
  const [metadataPart, contentPart] = base64String.split(',');

  const filenameMatch = metadataPart.match(/filename=(.*?);/);
  const filename = filenameMatch ? filenameMatch[1] : name;

  const binaryString = atob(contentPart);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: 'application/pdf' });

  return new File([blob], filename, { type: 'application/pdf' });
};

interface TriadaProps {
  decimal?: number;
  formatterProps?: NumericFormatProps;
  isTiin?: boolean;
}

export const triada = (
  value: string | number = '',
  props: TriadaProps = {}
): string => {
  let num = value && value !== 'null' ? _.clone(value) : 0;
  if (Number.isNaN(Number(num))) return String(num);
  const { decimal, isTiin, formatterProps } = props;

  if (isTiin) {
    num = Number(num) / 100;
  }
  const numStr = decimal ? Number(num).toFixed(decimal) : String(num);
  return numericFormatter(numStr, {
    thousandSeparator: ' ',
    ...formatterProps,
  });
};

export const getLang = () => {
  const lang = localStorage.getItem('lang');
  const supportedLang = SUPPORTED_LANGUAGES.find((el) => el.value === lang);
  return supportedLang?.value || 'ru';
};

export const getCurrency = (currency: Currency) => {
  switch (currency) {
    case 'UZS':
      return 'currency_options.UZS';
    case 'USD':
      return 'currency_options.USD';
    case 'EUR':
      return 'currency_options.EUR';

    default:
      return 'currency_options.UZS';
  }
};

export type ProfileRoles = {
  isAdmin?: boolean | null;
  isBranchEmploye?: boolean | null;
  isHeadOfficeEmployee?: boolean | null;
  isManager?: boolean | null;
};

export const checkRole = (roles?: ProfileRoles | null): UserRoles => ({
  isAdmin: !!roles?.isAdmin,
  isBranchEmploye: !!roles?.isBranchEmploye,
  isHeadOfficeEmployee: !!roles?.isHeadOfficeEmployee,
  isManager: !!roles?.isManager,
});
